import {ACTTYPE_DUMMY, ACTTYPE_SET_CID, ACTTYPE_SET_TAG} from "./appstate";
import {storageGetItem, storageSetItem, storageRemoveItem} from "lib/storage";


const setCid = function(value) {
    // store to sessionStorage
    storageSetItem("cid", value);

    return {
        type: ACTTYPE_SET_CID,
        value: value,
    };
};


const setCidDefault = function(value) {
    let cid;

    // try restore from sessionStorage
    cid = storageGetItem("cid");

    // fallback
    if (cid == null) {
        cid = value;
    }

    return {
        type: ACTTYPE_SET_CID,
        value: cid,
    };
};


const clrCidDefault = function() {
    storageRemoveItem("cid");

    // Dummy ActionCreator
    return {
        type: ACTTYPE_DUMMY
    };
};


function setTag(value) {
    // store to sessionStorage
    storageSetItem("tag", value);

    return {
        type: ACTTYPE_SET_TAG,
        value: value,
    };
};


function setTagDefault(defaultValue) {
    let storageValue;
    let value;

    // try restore from sessionStorage
    storageValue = storageGetItem("tag");

    // restore from storage or default
    if (storageValue !== null) {
        value = storageValue;
    }
    else {
        value = defaultValue;
    }

    return {
        type: ACTTYPE_SET_TAG,
        value: value,
    };
};


function clrTagDefault() {
    storageRemoveItem("tag");

    // Dummy ActionCreator
    return {
        type: ACTTYPE_DUMMY
    };
};


export {
    setCid,
    setCidDefault,
    clrCidDefault,
    setTag,
    setTagDefault,
    clrTagDefault,
};
